import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar, Button } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';

import GenericSelection from '../../../Common/GenericSelection';
import { isElegant } from '../../../../actions/root_url';

const propTypes = {
  methodSelected: PropTypes.string,
  productQuantityA: PropTypes.string,
  productQuantityB: PropTypes.string,
  discountValue: PropTypes.string,
  discountType: PropTypes.string,
  handleSelectionChange: PropTypes.func,
  handleDiscountButtonClick: PropTypes.func,
  handleTextInputChange: PropTypes.func,
};

const defaultProps = {
  methodSelected: '',
  productQuantityA: '',
  productQuantityB: '',
  discountValue: '',
  discountType: '',
  handleSelectionChange: () => {},
  handleDiscountButtonClick: () => { },
  handleTextInputChange: () => { },
};

const methodOptions = [
  { label: 'Every', value: 'Every' },
  { label: 'Each', value: 'Each' },
];

const BuyAGetBFields = ({
  methodSelected,
  productQuantityA,
  productQuantityB,
  discountValue,
  discountType,
  handleSelectionChange,
  handleDiscountButtonClick,
  handleTextInputChange,
}) => (
  <div className="promo-fields-b">
      <div className="method-selection">
        <GenericSelection
          translation={<Translate value="method" />}
          setSelected={({ value }) => handleSelectionChange(value, 'methodSelected')}
          value={methodSelected}
          options={methodOptions}
          colon
        />
      </div>
    <div className="flex-row">
      <label htmlFor="qty-label" className="field-margin"><Translate value="qty" />:</label>
      <div className="flex-row" id="buy-a-get-b-input">
        <label htmlFor="prod-qty-A" className="field-margin"><Translate value="buy" /></label>
        <div className="buy-a-get-b-input-format">
          <input
            id="qty-A-text-input"
            name="productQuantityA"
            className="text-input-field"
            type="text"
            value={productQuantityA}
            onChange={handleTextInputChange}
          />
          <span>(A)</span>
        </div>
        <label htmlFor="prod-qty-B" className="field-margin"><Translate value="get" /></label>
        <div className="buy-a-get-b-input-format">
          <input
            id="qty-B-text-input"
            name="productQuantityB"
            className="text-input-field"
            type="text"
            value={productQuantityB}
            onChange={handleTextInputChange}
          />
          <span>(B)</span>
        </div>
      </div>
    </div>
    <div className="discount-field">
      <label htmlFor="discount" className="field-margin "><Translate value="discount" /> (B):</label>
      {/* <div className="discount-input-format"> */}
        <input
          id="discount-text-input"
          name="discountValue"
          className="text-input-field"
          type="text"
          value={discountValue}
          onChange={handleTextInputChange}
          placeholder="free"
        />
        {/* <span>(B)</span> */}
      {/* </div> */}
      <ButtonToolbar>
        <Button
          bsStyle={(discountType === 'Dollar') ? 'success' : 'null'}
          onClick={() => handleDiscountButtonClick('Dollar')}
        >
          <em className="fa fa-usd" />
        </Button>
        <Button
          bsStyle={(discountType === 'Percent') ? 'success' : 'null'}
          onClick={() => handleDiscountButtonClick('Percent')}
        >
          <em className="fa fa-percent" />
        </Button>
      </ButtonToolbar>
    </div>
  </div>
);

BuyAGetBFields.propTypes = propTypes;
BuyAGetBFields.defaultProps = defaultProps;

export default BuyAGetBFields;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/PromotionsPage/components/BuyAGetBFields.jsx